import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=848566f4&scoped=true&"
import script from "./CompanyEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompanyEdit.vue?vue&type=style&index=1&id=848566f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848566f4",
  null
  
)

export default component.exports